import { Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const HeatExchangerSup = ({ styles, techData, heatRecovery }) => {
  const { t } = useTranslation();
  return (
    <View style={{ ...styles["section-wrapper"], marginTop: "5px" }} break>
      <View style={styles.heading}>
        <View style={styles["heading-flex"]}>
          <Text
            style={{
              ...styles.title,
              width: "5%",
              borderRight: "2px solid white",
            }}
          >
            {heatRecovery === "Rotary heat exchanger" ? "RC" : "PC"}
          </Text>
          <View style={styles["inner-flex"]}>
            <Text style={styles.title}>
              {heatRecovery === "Rotary heat exchanger"
                ? t("techCard.RotaryHeatSec").toUpperCase()
                : t("techCard.PlateHeatSec").toUpperCase()}
            </Text>
            <View style={styles["inner-inner"]}>
              <Text style={styles.title}>
                {t("techCard.PressureDrop")} [Pa]:
              </Text>
              <Text style={styles.title}>{techData.rec_Sup_PressureDrop}</Text>
            </View>
          </View>
        </View>
      </View>
      <Text style={styles["sm-pad"]}>
        {heatRecovery === "Rotary heat exchanger"
          ? t("techCard.RotaryHeat").toUpperCase()
          : t("techCard.PlateHeat").toUpperCase()}
      </Text>
      <Text style={styles["sm-pad"]}>{techData.calculation.rec_Model}</Text>
      <View style={styles.flex}>
        <View style={{ ...styles.left, paddingRight: "5px" }}>
          <View style={styles["md-flex"]}>
            <Text style={[styles.label, styles.heat]}>
              {t("techCard.HeatExcSec.HeatingMode")}:
            </Text>
            <Text></Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.StanAirVol")} m³/h:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.sup_AirVolumeFlow}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.FaceAirVelo")} m/s:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.sup_AirVelocity}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.HeatExcSec.InletTemp")} °C /{" "}
              {t("techCard.HeatExcSec.RelativeHum")} %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.sup_AirTempIn} /{" "}
              {techData.calculation.winterRecCalculation.sup_HumidityIn}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.HeatExcSec.OutletTemp")} °C /{" "}
              {t("techCard.HeatExcSec.RelativeHum")} %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.sup_AirTempOut} /{" "}
              {techData.calculation.winterRecCalculation.sup_HumidityOut}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.TempEff")} (EN 308) %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.sup_Efficiency}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.HumEff")} (EN 308) %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.sup_LatentEfficiency}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.EnergyEff")} (DIN EN 13053) %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.sup_EnergyEfficiency}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.TempEff")} ErP Lot 6 %:
            </Text>
            <Text style={styles.value}>
              {
                techData.calculation.winterRecCalculation
                  .sup_TemperatureEfficiency
              }{" "}
              (2018 ready)
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.PressureDrop")} (
              {t("techCard.HeatExcSec.ActualDens")}) Pa:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.sup_AirPressureDrop}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.PressureDrop")} (
              {t("techCard.HeatExcSec.StandardDens")}) Pa:
            </Text>
            <Text style={styles.value}>
              {
                techData.calculation.winterRecCalculation
                  .sup_ExternalPDStandardDensity
              }
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.TotalHeat")} kW:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.sup_TotalHeat}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.MoistRec")} g/kg:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.winterRecCalculation.moistureRecovery}
            </Text>
          </View>
        </View>
        <View style={styles.right}>
          <View style={styles["md-flex"]}>
            <Text style={[styles.label, styles.cool]}>
              {t("techCard.HeatExcSec.CoolingMode")}:
            </Text>
            <Text></Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.StanAirVol")} m³/h:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.sup_AirVolumeFlow}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.FaceAirVelo")} m/s:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.sup_AirVelocity}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.HeatExcSec.InletTemp")} °C /{" "}
              {t("techCard.HeatExcSec.RelativeHum")} %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.sup_AirTempIn} /{" "}
              {techData.calculation.summerRecCalculation.sup_HumidityIn}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles["wide-label"]}>
              {t("techCard.HeatExcSec.OutletTemp")} °C /{" "}
              {t("techCard.HeatExcSec.RelativeHum")} %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.sup_AirTempOut} /{" "}
              {techData.calculation.summerRecCalculation.sup_HumidityOut}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.TempEff")} (EN 308) %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.sup_Efficiency}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.HumEff")} (EN 308) %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.sup_LatentEfficiency}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.EnergyEff")} (DIN EN 13053) %:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.sup_EnergyEfficiency}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.TempEff")} ErP Lot 6 %:
            </Text>
            <Text style={styles.value}>
              {
                techData.calculation.summerRecCalculation
                  .sup_TemperatureEfficiency
              }{" "}
              (2018 ready)
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.PressureDrop")} (
              {t("techCard.HeatExcSec.ActualDens")}) Pa:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.sup_AirPressureDrop}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.PressureDrop")} (
              {t("techCard.HeatExcSec.StandardDens")}) Pa:
            </Text>
            <Text style={styles.value}>
              {
                techData.calculation.summerRecCalculation
                  .sup_ExternalPDStandardDensity
              }
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.TotalHeat")} kW:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.sup_TotalHeat}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.MoistRec")} kg/h:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.summerRecCalculation.moistureRecovery}
            </Text>
          </View>
        </View>
      </View>
      <View style={[styles.extras, styles.flex]}>
        <View style={{ ...styles.left, paddingRight: "5px" }}>
          {heatRecovery === "Plate heat exchanger" ? (
            <View style={styles["md-flex"]}>
              <Text style={styles.label}>
                {t("techCard.GenProdSpec.Type")}:
              </Text>
              <Text style={styles.value}>{techData.calculation.rec_Type}</Text>
            </View>
          ) : (
            <></>
          )}
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.HeatExcSec.PlateMat")}:
            </Text>
            <Text style={styles.value}>
              {techData.calculation.rec_Material}
            </Text>
          </View>
          {heatRecovery === "Rotary heat exchanger" ? (
            <View style={styles["md-flex"]}>
              <Text style={styles.label}>
                {t("techCard.HeatExcSec.Controller")} Hz:
              </Text>
              <Text style={styles.value}>
                {techData.calculation.rec_Controller}
              </Text>
            </View>
          ) : (
            <></>
          )}
        </View>
        <View style={styles.right}>
          {heatRecovery !== "Rotary heat exchanger" ? (
            <>
              <View style={styles["md-flex"]}>
                <Text style={styles.label}>
                  {t("techCard.HeatExcSec.Bypass")}:
                </Text>
                <Text style={styles.value}>
                  {techData.calculation.rec_Bypass}
                </Text>
              </View>
              <View style={styles["md-flex"]}>
                <Text style={styles.label}>
                  {t("techCard.ConnSec.TotalTorque")} [Nm]:
                </Text>
                <Text style={styles.value}>
                  {techData.calculation.rec_Torque}
                </Text>
              </View>
            </>
          ) : (
            <View style={styles["md-flex"]}>
              <Text style={styles.label}>
                {t("techCard.HeatExcSec.StepMotor")} kW:
              </Text>
              <Text style={styles.value}>
                {techData.calculation.rec_StepMotor}
              </Text>
            </View>
          )}
        </View>
      </View>
      {techData.calculation.rec_SpeedRegulator !== "-" ? (
        <View style={styles.extras}>
          <Text>{t("techCard.HeatExcSec.WithSpeedRegulator")}</Text>
          <Text>{techData.calculation.rec_SpeedRegulator}</Text>
        </View>
      ) : null}
    </View>
  );
};

export default HeatExchangerSup;
